module.exports = __webpack_public_path__ + "img/chemicals-icon.e5f1157c.svg";